"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _BannerPosition = _interopRequireDefault(require("../../../components/BannerPosition"));

var _withChildrenIfStaticBuild = _interopRequireDefault(require("../../../withChildrenIfStaticBuild"));

// HOC for static build
var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 'auto'
      },
      image: {
        maxWidth: '100%'
      }
    }
  );
}, {
  name: 'ProductDetailPageBanner'
});

function ProductDetailPageBanner(_ref) {
  var bannerPositionProps = _ref.bannerPositionProps,
      pClasses = _ref.classes,
      className = _ref.className,
      hideSkeleton = _ref.hideSkeleton,
      position = _ref.position,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["bannerPositionProps", "classes", "className", "hideSkeleton", "position"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_BannerPosition.default, (0, _extends2.default)({}, bannerPositionProps, {
    className: (0, _clsx.default)(classes.root, className),
    sizes: {
      xs: 'large-rectangle',
      sm: 'large-rectangle',
      md: 'large-rectangle',
      lg: 'large-rectangle',
      xl: 'large-rectangle'
    },
    position: position,
    hideSkeleton: hideSkeleton
  })));
}

process.env.NODE_ENV !== "production" ? ProductDetailPageBanner.propTypes = {
  bannerPositionProps: _propTypes.default.shape({}),
  classes: _propTypes.default.shape({
    image: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  hideSkeleton: _propTypes.default.bool,
  position: _propTypes.default.string.isRequired
} : void 0;
ProductDetailPageBanner.defaultProps = {
  bannerPositionProps: undefined,
  classes: undefined,
  className: undefined,
  hideSkeleton: undefined
};
var ProductDetailPageBannerWrapped = (0, _withChildrenIfStaticBuild.default)(ProductDetailPageBanner);
var _default = ProductDetailPageBannerWrapped;
exports.default = _default;